<div class="table-responsive">
  <table class="table table-hover">
    <thead>
    <tr>
      <th class="w-50">{{'doctrine.option.name'|translate}}</th>
      <th>{{'doctrine.option.required'|translate}}</th>
      <th>{{'doctrine.option.position'|translate}}</th>
      <th>{{'global.actions'|translate}}</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let serviceSubjectItem of getServiceSubjectItems();let i = index">
      <tr>
        <td>{{serviceSubjectItem.name}}</td>
        <td>{{((serviceSubjectItem.required) ? 'global.yes' : 'global.no')|translate}}</td>
        <td>
          <input class="form-control w-50" (blur)="positionChange(serviceSubjectItem.position, serviceSubjectItem.id)"
                 [name]="positionItem+i"
                 type="number" [(ngModel)]="serviceSubjectItem.position" #positionItem="ngModel">
        </td>
        <td>
          <ng-container *ngIf="archive">
          <span class="action-button">
            <a class="ripple light ms-2"
               (click)="openReAddServiceSubjectItem(serviceSubjectItem.id, serviceSubjectItem.name)">
              <i class="fa fa-plus fa-lg"></i>
            </a>
          </span>
          </ng-container>
          <ng-container *ngIf="!archive">
          <span class="action-button">
            <a class="ripple light ms-2" (click)="openManageServiceSubjectItemModal(serviceSubjectItem)">
            <i class="fa fa-pencil fa-lg"></i>
          </a>
          </span>
            <span class="action-button">
                <a class="ripple light ms-2"
                   (click)="openSoftDeleteConfirm(serviceSubjectItem.id, serviceSubjectItem.name)">
                <i class="fa fa-remove fa-lg"></i>
              </a>
              </span>
          </ng-container>
        </td>
      </tr>
      <ng-container *ngIf="!archive">
        <ng-container
          *ngTemplateOutlet="childServiceSubjectItemTemplate; context: { $implicit: serviceSubjectItem.serviceSubjectItems, idx: i}"></ng-container>
      </ng-container>
    </ng-container>
    </tbody>
  </table>
</div>

<button *ngIf="!archive" type="button" class="btn btn-simple ripple me-2 btn-primary light"
        (click)="openManageServiceSubjectItemModal()">
  <span class="feather icon-plus"></span> {{'global.add'|translate}}
</button>
<button *ngIf="!archive" class="btn btn-primary ripple light pull-right" (click)="viewArchiveServiceRequestItems()"
        type="button">{{'global.view_archive'|translate}}</button>
<button *ngIf="archive" class="btn btn-primary ripple light pull-right mb-3" (click)="viewServiceRequestItems()"
        type="button">{{'admin.service.subject.view.view_subjects'|translate}}</button>

<ng-template #childServiceSubjectItemTemplate let-serviceSubjectItems let-idx="idx">
  <ng-container *ngFor="let serviceSubjectItem of getFilteredItems(serviceSubjectItems); let i = index">
    <tr>
      <td>{{calculateIndent(idx)}}{{serviceSubjectItem.name}}</td>
      <td>{{((serviceSubjectItem.required) ? 'global.yes' : 'global.no')|translate}}</td>
      <td>
        <input class="form-control w-50" (blur)="positionChange(serviceSubjectItem.position, serviceSubjectItem.id)"
               [name]="positionItem+i"
               type="number" [(ngModel)]="serviceSubjectItem.position" #positionItem="ngModel">
      </td>
      <td>
        <ng-container *ngIf="archive">
          <span class="action-button">
            <a class="ripple light ms-2"
               (click)="openReAddServiceSubjectItem(serviceSubjectItem.id, serviceSubjectItem.name)">
              <i class="fa fa-plus fa-lg"></i>
            </a>
          </span>
        </ng-container>
        <ng-container *ngIf="!archive">
          <span class="action-button">
            <a class="ripple light ms-2" (click)="openManageServiceSubjectItemModal(serviceSubjectItem)">
            <i class="fa fa-pencil fa-lg"></i>
          </a>
          </span>
          <span class="action-button">
                <a class="ripple light ms-2"
                   (click)="openSoftDeleteConfirm(serviceSubjectItem.id, serviceSubjectItem.name)">
                <i class="fa fa-remove fa-lg"></i>
              </a>
              </span>
        </ng-container>
      </td>
    </tr>
    <ng-container *ngIf="serviceSubjectItem.serviceSubjectItems">
      <ng-container
        *ngTemplateOutlet="childServiceSubjectItemTemplate; context: { $implicit: serviceSubjectItem.serviceSubjectItems, idx: idx + '.' + i}"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- start soft delete modal -->
<app-modal-basic #deleteServiceRequestItemModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.actions.delete' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="deleteServiceRequestItemModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="serviceSubjectItemName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteServiceRequestItemModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="softDeleteServiceSubjectItem()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
<!-- end soft delete modal -->

<!-- start manage service request item modal -->
<app-modal-basic #manageServiceRequestItemModal [dialogClass]="'modal-xl'">
  <div class="app-modal-header">
    <h4
      class="modal-title">{{(isEdit ? 'global.edit' : 'global.add') | translate }} {{ 'admin.service.service_tunnel.title' | translate }}</h4>
    <button type="button" class="close basic-close"
            (click)="manageServiceRequestItemModal.hide();manageServiceRequestItemForm.reset();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #manageServiceRequestItemForm="ngForm">
      <div class="row">
        <ng-container *ngFor="let field of serviceSubjectItem.translationKeys">
          <ng-container *ngFor="let t of serviceSubjectItem.translationEntries[field]; let j=index">
            <div class="form-group col-sm-6" *ngIf="field == 'name' && t[0]=='nl'">
              <label class="float-label">{{'admin.service.service_tunnel.name'|translate}} ({{ this.languageMap[t[0]]}})
                <span>*</span>
              </label>
              <input type="text" [name]="'nameItem'+j" #nameItem="ngModel"
                     [(ngModel)]="serviceSubjectItem.translations[field][t[0]]"
                     class="form-control" required>
              <div class="messages text-danger" *ngIf="nameItem.invalid && nameItem.dirty && nameItem.errors?.required">
                {{'errors.required'|translate}}
              </div>
            </div>
          </ng-container>
        </ng-container>
        <div class="form-group form-default form-static-label col-6">
          <label class="float-label">{{'global.status'|translate}}<span class="star">*</span></label>
          <ng-select class="ng-select" name="status" bindValue="value" #status="ngModel"
                     [(ngModel)]="serviceSubjectItem.status"
                     [clearable]="false" [items]="statuses" required>
          </ng-select>
          <div class="messages text-danger"
               *ngIf="status.invalid && status.dirty && status.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
        <div class="form-group form-default form-static-label col-6">
          <label class="float-label">{{'doctrine.option.parent'|translate}}<span class="star">*</span></label>
          <ng-select class="ng-select" name="parentItem" #parentItem="ngModel" [(ngModel)]="serviceSubjectItem.parent"
                     [clearable]="false" bindValue="id" bindLabel="name" [items]="parents" required>
          </ng-select>
          <div class="messages text-danger"
               *ngIf="parentItem.invalid && parentItem.dirty && parentItem.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
        <div class="col-sm-6 border-checkbox-section d-flex align-items-center pt-2 ps-2">
          <div class="border-checkbox-group border-checkbox-group-primary">
            <input type="checkbox" [id]="'requiredItem'" class="border-checkbox" [name]="'requiredItem'"
                   #requiredItem="ngModel"
                   [(ngModel)]="serviceSubjectItem.required">
            <label class="border-checkbox-label mb-0"
                   [for]="'requiredItem'">{{'admin.backoffice.option.add_option.is_required'|translate}}</label>
          </div>
        </div>
      </div>
      <ng-container *ngFor="let field of serviceSubjectItem.translationKeys">
        <ng-container *ngFor="let t of serviceSubjectItem.translationEntries[field]; let j=index">
            <div *ngIf="field == 'description' && t[0]=='nl'">
              <app-editor name="descriptionItemNl"
                          [(ngModel)]="serviceSubjectItem.translations[field][t[0]]"
                          [required]="true"
                          label="{{'admin.service.service_tunnel.description'|translate}} ({{ this.languageMap[t[0]]}})"
                          toolsType="minimal"
                          [extraTools]="['link','btn-link']"
              ></app-editor>
            </div>
        </ng-container>
      </ng-container>
      <div class="row">
        <div class="col-sm-6">
          <app-file-uploader
            [(ngModel)]="serviceSubjectItem.thumbnail"
            [ngModelOptions]="{standalone: true}"
            label="{{'doctrine.service_subject.thumbnail' | translate}}"
            description="{{'validators.image' | translate}}"
            accept=".png,.gif,.jpg"
            scope="backoffice"
            bupload="serviceSubjectItem.thumbnail"
            fieldName="thumbnail"
          ></app-file-uploader>
        </div>
        <div class="col-sm-6">
          <app-file-uploader
            [(ngModel)]="serviceSubjectItem.attachments"
            [ngModelOptions]="{standalone: true}"
            label="{{'doctrine.service_subject.attachments' | translate}}"
            description="{{'validators.file' | translate}}"
            accept=".png,.gif,.jpg,.xls,.xlsx,.doc,.docx,.pdf"
            scope="backoffice"
            bupload="serviceSubjectItem.attachments"
            [queueLimit]="5"
            fieldName="attachments"
          ></app-file-uploader>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="manageServiceRequestItemModal.hide();manageServiceRequestItemForm.reset();">
      {{'global.cancel'|translate}}
    </button>
    <button type="button" class="btn btn-primary ripple light" (click)="submitManageServiceRequestItem()"
            [disabled]="manageServiceRequestItemForm.invalid">
      {{(isEdit ? 'global.save_changes' : 'global.actions.add') | translate}}</button>
  </div>
</app-modal-basic>
<!-- end manage service request item modal -->

<!-- Re Add ServiceRequestItem Modal -->
<app-modal-basic #reAddServiceRequestItemModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'Option'} }}</h4>
    <button type="button" class="close basic-close" (click)="reAddServiceRequestItemModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <b [innerHTML]="serviceSubjectItemName"></b></p>
    <div class="form-group row">
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="reAddServiceRequestItemModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="reAddServiceRequestItem()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>
